module.exports = __webpack_public_path__ + "static/media/alert-blue.82c0668a.png";